import $ from 'jquery'
import Component from './component'

export class Certificates extends Component {
  constructor(ctx, ev) {
    super(ctx, ev)

    // classes extensions
    Object.assign(this.classes, {
      item: '.js-certificates-item',
      link: '.js-certicates-item-link',
      list: '.js-certicates-item-list',
      listItem: '.js-certicates-item-list-item',
    })

    this.bindItems()
  }

  bindItems() {
    this.$ctx.on('click', this.classes.item, (ev) => {
      const $item = $(ev.currentTarget)
      $item.toggleClass(this.classStates.active)
    })

    this.$ctx.on('click', this.classes.listItem, (ev) => {
      ev.stopPropagation()
    })
  }

  onResize() {
    // noop
  }
}
